<template>
  <main-layout>
	<section role="main" aria-label="תוכן" class="content" id="RhythmAudition">
			<div class="divider"></div>
			<div class="info-content">
				<div class="fill">
					<img :key=img2srcD src="photos/rhythm/pic01.jpg" alt="איך מצטרפים?" class="fillImgFront" >
				</div>
				<div class="textbox-bounds textbox-bounds-unbound-double">
						<div class="textbox-tab-mark""></div>
						<div id="origamiform" data-origamiformname="form_60535ba032c9a" data-origamiformid="1567559bf56faf7997f51ba33141a2b6771506e818c0d568276c029958d25d80e1d90697b459f32c49493c0c970c2fae45e5fef3ff19eaf9b186119c548ff7b1WGbTrHOUdQFuzYBbXJWvjo4+W02Y+3kQ74cxYTkLqoSiR8SEp/ikcr5MnCFNuUijxqG1lvLz24GaEixGslti2lqQ7X1NmSrZAoOZUDXWwVPOb9NzdVasFPQB2fw0RqEX" ></div>
						<div class="textbox-text">
							
						</div>
					
				</div>
			</div>
			<br>
			<div id="FAQSdivider" class="divider"></div>
			
		</section>
  </main-layout>
</template>
<script>
var APIbase = "https://yard-bands.herokuapp.com"
import axios from 'axios'
  import MainLayout from '../layouts/Origami.vue'
   import VLink from '../components/VLink.vue'
  import VueScrollTo from 'vue-scrollto'

/* eslint-disable no-useless-escape */
import postscribe from 'postscribe'

  export default {
  mounted:function(){
    postscribe('#origamiform', '<script src="https://public.origamicloud.ms/web_forms/js"><\/script>')
    postscribe('#origamiform', '<script type="text/javascript"> ORIGAMI_FORMS["form_60535ba032c9a"] = { "fields": { "Lead_First_name" : { "value" : "testing", "hidden" : true }, }, "rtl": "1" };  <\/script>')
  },
    components: {
      MainLayout,VLink
    },
	created () {
		this.texts = {}
	},
	ready:function(){
    },
	data() {
		return {
		}
	},
	watch: {

		
	},
	methods: {
		scrollToFooter(){
			this.$scrollTo(".credits", 0, {})
		}
	}

  }
</script>



// WEBPACK FOOTER //
// RhythmManual.vue?eccf07e0